const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000');
const CDN_URL = process.env.REACT_APP_CDN_URL;

export const getImageUrl = (imagePath, { size } = {}) => {
  if (!imagePath) return null;

  // Strip known CDN prefix so optimization still applies; pass other absolute URLs through unchanged
  if (CDN_URL && imagePath.startsWith(CDN_URL)) {
    imagePath = imagePath.slice(CDN_URL.length);
  } else if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  const cleanPath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
  // Videos are served from the site itself (every upload is also on the
  // origin, cached by Cloudflare): the storefront's security policy allows
  // media only from its own origin, while photos may come from the CDN.
  const base = isVideoPath(imagePath) ? API_BASE_URL : (CDN_URL || API_BASE_URL);

  if (size && !isVideoPath(imagePath)) {
    const optimized = toOptimizedPath(cleanPath, size);
    return `${base}/${optimized}`;
  }

  return `${base}/${cleanPath}`;
};

export const isVideoPath = (path) =>
  /\.(mp4|mov|webm)$/i.test(path || '');

/**
 * Converts e.g. "uploads/products/CY014_0.jpeg" →
 *   "uploads/optimized/products/thumb/CY014_0.webp" (size='thumb')
 *   "uploads/optimized/carousels/CY014_1.webp"     (size='carousel')
 */
function toOptimizedPath(cleanPath, size) {
  const parts = cleanPath.replace(/^uploads\//, '');

  if (size === 'carousel' && parts.startsWith('carousels/')) {
    const filename = parts.replace('carousels/', '');
    const name = filename.replace(/\.[^.]+$/, '');
    return `uploads/optimized/carousels/${name}.webp`;
  }

  if (parts.startsWith('products/')) {
    const filename = parts.replace('products/', '');
    const name = filename.replace(/\.[^.]+$/, '');
    const sizeDir = size === 'carousel' ? 'large' : size;
    return `uploads/optimized/products/${sizeDir}/${name}.webp`;
  }

  return cleanPath;
}
